import React from 'react';
import { useFormik } from 'formik';
import { Container, Row, Col } from 'react-bootstrap';

const validate = values => {
    const errors = {};

    if (!values.firstName) {
        errors.firstName = 'Required';
    } else if (values.firstName.length > 15) {
        errors.firstName = 'Must be 15 characters or less';
    }

    if (!values.mobile) {
        errors.mobile = 'Required';
    } else if (!/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(values.mobile)) {
        errors.mobile = 'Invalid Mobile number';
    }

    if (!values.email) {
        errors.email = 'Required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = 'Invalid email address';
    }

    if (!values.subject) {
        errors.subject = 'Required';
    } else if (values.subject.length > 25) {
        errors.subject = 'Must be 25 characters or less';
    }

        return errors;
    };

    const Contactform = () => {
        const formik = useFormik({
            initialValues: {
                firstName: '',
                email: '',
                mobile: '',
                subject: '',
                message: '',
            },
            validate,
            onSubmit: values => {
                alert('Submited Suceesfully');
            },
        });
        return (
            <form onSubmit={formik.handleSubmit} className= 'form1'>
                <Container>
                    <Row className='rowH'>Send Your Message To us</Row>
                    <Row className='row1'>
                        <Col>
                            <div><label htmlFor="firstName">First Name</label></div>
                            <input
                                id="firstName"
                                name="firstName"
                                type="text"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.firstName}
                            />
                            {formik.touched.firstName && formik.errors.firstName ? (
                                <div className= 'error'>{formik.errors.firstName}</div>
                            ) : null}
                        </Col>
                        <Col>
                            <div><label htmlFor="email">Email Address</label></div>
                            <input
                                id="email"
                                name="email"
                                type="email"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.email}
                            />
                            {formik.touched.email && formik.errors.email ? (
                                <div className= 'error'>{formik.errors.email}</div>
                            ) : null}
                        </Col>
                    </Row>
                    <Row className='row1'>
                        <Col>
                            <div><label htmlFor="mobile">Mobile Number</label></div>
                            <input
                                id="mobile"
                                name="mobile"
                                type="tel"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.mobile}
                            />
                            {formik.touched.mobile && formik.errors.mobile ? (
                                <div className= 'error'>{formik.errors.mobile}</div>
                            ) : null}
                        </Col>
                        <Col>
                            <div><label htmlFor="subject">Subject</label></div>
                            <input
                                id="subject"
                                name="subject"
                                type="text"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.subject}
                            />
                            {formik.touched.subject && formik.errors.subject ? (
                                <div className= 'error'>{formik.errors.subject}</div>
                            ) : null}
                        </Col>
                    </Row>
                    <Row className='row2'>
                        <div><label htmlFor="message">Message</label></div>
                        <textarea
                            id="message"
                            name="message"
                            rows="5"
                            cols="10"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.message}
                        >
                        </textarea>
                        {formik.touched.message && formik.errors.message ? (
                            <div className= 'error'>{formik.errors.message}</div>
                        ) : null}
                    </Row>
                    <Row className='row2'>
                        <button type="submit">Submit</button>
                    </Row>
                </Container>
            </form>
        );
    }

    export default Contactform ;